import { MODULES_PERMISSIONS } from '@lumapps/directories/permissions';
import { isFeatureEnabled } from '@lumapps/features';
import { isUserAllowed } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { USER_DIRECTORY_ADMIN_FF } from '../constants';

export const isUserDirectoryAdminEnabled = isFeatureEnabled(USER_DIRECTORY_ADMIN_FF);

const hasUserDirectoryEditPermission = isUserAllowed(MODULES_PERMISSIONS.USER_DIRECTORY_EDIT);

export const isUserDirectoryEditAllowed = createSelector(
    isUserDirectoryAdminEnabled,
    hasUserDirectoryEditPermission,
    (isEnabled, isAllowed) => isEnabled && isAllowed,
);
